import React from 'react';
import { useTranslation } from 'react-i18next';
import './TextIndicator.scss';
import { translateMultipleText } from '../../../../../services/stringUtil';
import useProjectsInPreparationPipelineCounts from './useProjectsInPreparationPipelineCounts';

type Props = {
  card: any;
  analyticIndicator?: boolean;
  onClickMore?: any;
};

const TextIndicator = ({ card, analyticIndicator = false, onClickMore }: Props) => {
  const { t } = useTranslation(analyticIndicator ? 'contentManager' : '');
  const { pipelineACount, pipelineBCount } = useProjectsInPreparationPipelineCounts(card);

  return (
    <div className={analyticIndicator ? 'text-analytic-indicator-container' : 'text-indicator-container'}>
      <span className="value-text">{card.data ? card.data.value : '-'}</span>
      <span className="light-text">{card.title ? t(card.title) : ''}</span>
      <button className="bold-text text-inidicator-subtitle" onClick={onClickMore} tabIndex={30}>
        {card.subtitle ? translateMultipleText(card.subtitle, t) : ''}
      </button>

      {card.indicatorKey === 'PROJECTS_IN_PREPARATION' && (
        <div className='pipeline-info'>
          <p><span>{pipelineACount}</span>{` ${t('pipeline_a')}`}</p>
          <p><span>{pipelineBCount}</span>{` ${t('pipeline_b')}`}</p>
        </div>
      )}
    </div>
  );
};

export { TextIndicator };
